module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av36-da315d5d426432068a0276221441089b.jpg";